import React from 'react'

function DashboardMembership() {
  return <>
  
  <div>Bu sayfa Private MEmbership sayfasıdır</div>
  </>
    
}

export default DashboardMembership